import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
    isLogged: !!localStorage.getItem('token'),
    admin: false
}

const mutations = {
    LOGIN_USER (state) {
        state.isLogged = true
        if(localStorage.getItem('token') === 'admin') {
            state.admin = true
        }
    },
    
    LOGOUT_USER (state) {
        state.isLogged = false
        state.admin = false
    }
}

export default new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    state,
    mutations
})


// WEBPACK FOOTER //
// ./src/store/index.js